import React, { useEffect, useState } from 'react'
import Calendar from 'react-calendar';
import { UploadImage } from '../../../../components/Register/UploadFile'
import Button from '../../../../utils/components/Button/Button';
import Input from '../../../../utils/components/Input/Input';
import useModal from '../../../../utils/hooks/useModal';
import style from "./CreateAdmin.module.css"
const CreateAdmin = ({ admin = null, formik, isEdit = false, roles }) => {
  const [picture, setPicture] = useState(null);
  const [refBirthDate, isShowBirthDate, setIsShowBirthDate] = useModal(false)
  useEffect(() => {
    if (admin) {
      setPicture(admin && admin.picture && admin.picture.files && admin.picture.files.url && admin.picture.files.url.origin)
    }


    return () => {

    }
  }, [admin])

  return (
    <div>
      <div className={`row centerItems`}>
        <UploadImage
          isUpdate={!picture}
          classNameUpload={style.upload_image}
          picture={picture}
          setPicture={setPicture}
          setFile={(value) => { formik.setFieldValue("files", value) }}
        />
      </div>

      <div className={style.form_container}>
        <Input
          classNameInput={style.input_form}
          name="name"
          type="text"
          placeholder={'Nombre'}
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.errors.name}
        />

        <Input
          classNameInput={style.input_form}
          name="phone"
          type="text"
          placeholder={'Teléfono'}
          value={formik.values.phone}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.phone}
        />

      </div>
      <div className={style.form_container}>


        {
          !isEdit && <Input
            classNameInput={style.input_form}
            name="email"
            type="email"
            placeholder={'Correo'}
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.email}
          />
        }
        {
          !isEdit && <>
            <Input
              classNameInput={style.input_form}
              name="password"
              type="password"
              placeholder={'Contraseña'}
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.password}
            />
            <Input
              classNameInput={style.input_form}
              name="passwordConfirm"
              type="password"
              placeholder={'Confirme la contraseña'}
              value={formik.values.passwordConfirm}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.passwordConfirm}
            />
          </>
        }


      </div>
      <div className={style.form_container}>
        

        <select
          name={"gender"}
          className={`${style.input_select}`}
          value={formik.values.gender}
          onChange={formik.handleChange}
        >
          <option value="">Genero</option>
          <option value="male">Masculino</option>
          <option value="female">Femenino</option>
          <option value="another">Prefiero no decirlo</option>
        </select>
        <Input
          classNameInput={style.input_form}
          name="birthDate"
          type="text"
          placeholder={'Fecha de nacimiento'}
          value={new Date(formik.values.birthDate).toLocaleDateString()}
          onClick={() => setIsShowBirthDate(true)}
          onBlur={formik.handleBlur}
          error={formik.errors.birthDate}
        />
        {
          isShowBirthDate &&
          <div ref={refBirthDate}>
            <div
              style={{
                display: isShowBirthDate ? 'block' : 'none'
              }}
              className="calendar-register" >
              <Calendar
                maxDate={new Date()}
                onChange={(dateTime) => {
                  formik.setFieldValue('birthDate', new Date(dateTime));
                  setIsShowBirthDate(false)
                }
                }
              />
            </div>
          </div>


        }

      </div>

      <div className={style.form_container}>
        <Input
          classNameInput={style.input_form}
          name="description"
          type="text"
          placeholder={'Descripción'}
          value={formik.values.description}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.description}
        />
        <select
          className={`${style.input_select}`}
          name="adminRoleId"
          value={formik.values.adminRoleId}
          onChange={formik.handleChange}

        >  <option value="">Rol</option>
          {
            roles.map(role => (
              <option key={role._id} value={role._id}>{role.name}</option>
            ))
          }
        </select>
      </div>
      <div className='column centerContent mt-2'>
        <Button
          onClick={formik.handleSubmit}
          text={isEdit ? 'Actualizar' : 'Crear'}
        />
      </div>

    </div>
  )
}

export default CreateAdmin